import { ROLE_TYPE_CAREGIVER } from "../../../constants/RegisterConstants";
import { RouterAddress } from "../../../constants/RouterAddress";
import ResidentEntryLogPageContent from "../../resident/components/ResidentEntryLogPageContent";

type CaregiverDailyNotesPageProps = {
  allowSharedStaffAccess?: boolean;
  dashboardPathOverride?: string;
  sharedMode?: boolean;
};

const getUtcDateLabel = (value?: string) => {
  const parsed = new Date(String(value || "").trim());
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }
  return parsed.toISOString().slice(0, 10);
};

export const CaregiverDailyNotesPageContent = ({
  allowSharedStaffAccess = false,
  dashboardPathOverride = RouterAddress.CAREGIVER_HOME,
  sharedMode = false,
}: CaregiverDailyNotesPageProps) => (
  <ResidentEntryLogPageContent
    expectedRole={ROLE_TYPE_CAREGIVER}
    allowSharedStaffAccess={allowSharedStaffAccess}
    sharedMode={sharedMode}
    dashboardPathOverride={dashboardPathOverride}
    entryType="daily_note"
    pageTitle="Progress Notes"
    pageSubtitle="Share simple shift updates so the next person has a clear picture of the day."
    sectionTitle="Progress Notes"
    sectionDescription=""
    defaultComposerVisible={true}
    showComposerToggleButton={true}
    compactActionBar={true}
    compactDraftsAction={true}
    compactComposerLabel="New Entry"
    hideEntriesSection={!sharedMode}
    allowedCompactSections={sharedMode ? ["composer", "monthly", "recent", "drafts"] : ["composer", "drafts"]}
    enableMonthlyReport={sharedMode}
    monthlyReportTitle="Progress Notes Report"
    monthlyReportDescription="Review recent progress notes and generate a report."
    loadMonthlyReport={(backendAPIStore, residentId, options) => backendAPIStore.getResidentDailyNotesMonthlyDataset(residentId, options)}
    generateMonthlyReportDocument={(backendAPIStore, residentId, requestBody) => backendAPIStore.generateResidentDailyNotesReportDocument(residentId, requestBody)}
    loadEntriesPage={(backendAPIStore, residentId, options) =>
      backendAPIStore.getCaregiverResidentDailyNotesPage(residentId, options)}
    createEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.createCaregiverResidentDailyNote(residentId, payload)}
    updateEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.updateCaregiverResidentDailyNote(residentId, payload)}
    deleteDraft={(backendAPIStore, residentId, entryLogId) =>
      backendAPIStore.deleteCaregiverResidentDailyNote(residentId, entryLogId)}
    canEditEntry={(entry, currentUserId) => {
      if (sharedMode) return true;
      if (String(entry?.recordedByUserId || "").trim() !== String(currentUserId || "").trim()) {
        return false;
      }
      if (String(entry?.status || "").trim().toLowerCase() === "draft") {
        return true;
      }
      const entryDate = String(entry?.entryDate || "").trim() || getUtcDateLabel(entry?.occurredAt);
      return entryDate === new Date().toISOString().slice(0, 10);
    }}
  />
);

const CaregiverDailyNotesPage = () => (
  <CaregiverDailyNotesPageContent />
);

export default CaregiverDailyNotesPage;
